///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////

abcsetup.promos.gnp = abcsetup.promos.gnp || {};
abcsetup.promos.gnp.common = abcsetup.promos.gnp.common || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.promos.gnp.common = {

    /**
     *
     */
    init: function () {
        abcsetup.setTitle('GNP Promo');
        this.fieldsInit();
    },

    fieldsInit: function () {
        // Autopopulate promo name field based on promo type and supplier window start
        $('#app_promo__type').on('change', function () {

            var type = $("#app_promo__type option:selected").text() == '- select -' ? '' : $("#app_promo__type option:selected").text();
            var level = type.split(" ").pop();

            if ($(this).val() != '' && $("#app_promo__type option:selected").val() != 'gnp_central_banner_a') {
                $('#app_promo__name').val('GNP University Education Package - ' + level);
            } else {
                $('#app_promo__name').val(type);
            }
        });

        $(document).on('click', '.award-status-toggle input', function () {
            $(this).closest('.award-status-toggle').find('label').removeClass('active');
            const selectedRadio = $(this).closest('.award-status-toggle').find(':checked');
            selectedRadio.closest('label').addClass('active');

            if (selectedRadio.val() == 'reject') {
                $(this).closest('tr').find('.reject-input').attr('disabled', false);
                $(this).closest('tr').find('.reject-input').attr('required', true);
            } else {
                $(this).closest('tr').find('.reject-input').val("");
                $(this).closest('tr').find('.reject-input').attr('disabled', true);
                $(this).closest('tr').find('.reject-input').attr('required', false);
            }
        });

        // Change Cost For Partnership label based on promo type selected
        $('#app_promo__type').on('change', function () {
            if ($(this).val() == 'gnp_central_banner_a') {
                $("label[for='app_promo__cost_for_partnership']").text('Cost Per Week');
            }
            else {
                $("label[for='app_promo__cost_for_partnership']").text('Cost For Partnership');
            }
        });
    },

    fieldError: function() {
        var errorField = $('form').find('.invalid').first();
        //alert(errorField.parent().html());
        abcsetup.unblockUI();
    }

}
